import { render, staticRenderFns } from "./home_title.vue?vue&type=template&id=6ef309fe&scoped=true"
import script from "./home_title.vue?vue&type=script&lang=js"
export * from "./home_title.vue?vue&type=script&lang=js"
import style0 from "./home_title.vue?vue&type=style&index=0&id=6ef309fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef309fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef309fe')) {
      api.createRecord('6ef309fe', component.options)
    } else {
      api.reload('6ef309fe', component.options)
    }
    module.hot.accept("./home_title.vue?vue&type=template&id=6ef309fe&scoped=true", function () {
      api.rerender('6ef309fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_title.vue"
export default component.exports